export default function SyncableBatchChangeDirective() {
  return {
    template: require('./syncable-batch-change.html'),
    restrict: 'E',
    controller: 'SyncableBatchChangeController',
    controllerAs: 'syncableBatchChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
    },
  };
}
